import { memo, useCallback, useEffect, useState } from "react";
import { Button, Drawer } from "antd";
import PropTypes from "prop-types";
import JoinWalkPage from "@/components/join-a-walk/JoinWalkPage";
import T from "@/components/common/T";
import { useGlobalStore } from "@/context/useGlobalStore";

// Single source of truth for the "Join a Walk" action: renders a trigger button
// and owns the drawer that hosts <JoinWalkPage />. Style/label are supplied by
// the caller so the same behaviour works as a floating tab or a header CTA.
const JoinWalkButton = ({ children = "JOIN A WALK", type = "primary", ...buttonProps }) => {
    const [open, setOpen] = useState(false);
    const openDrawer = useCallback(() => setOpen(true), []);
    const closeDrawer = useCallback(() => setOpen(false), []);

    // Close signal fired by the create-walk "Pin" flow: the pin is placed on
    // the index map, so the drawer must get out of the way.
    const closeSignal = useGlobalStore((s) => s.joinWalkDrawerClose);
    useEffect(() => {
        if (closeSignal) setOpen(false);
    }, [closeSignal]);

    return (
        <>
            <Button type={type} onClick={openDrawer} {...buttonProps}>
                {children}
            </Button>
            <Drawer
                title={<T k="Join a Walk" />}
                placement="right"
                onClose={closeDrawer}
                size={1200}
                open={open}
                destroyOnHidden
                styles={{ body: { padding: 0 } }}
            >
                <JoinWalkPage />
            </Drawer>
        </>
    );
};

JoinWalkButton.propTypes = {
    children: PropTypes.node,
    type: PropTypes.string,
};

export default memo(JoinWalkButton);
